import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const NonProduct = props => {
	const classes = useStyles();
	const { height } = props;

	return (
		<Grid classes={{ root: classes.root }} style={{ height: height }}>
			<Grid classes={{ root: classes.bodyPage }}>
				<Grid style={{ textAlign: "center" }}>
					<img src={Images.icNonProduct} alt="icNonProduct" />
					<Grid classes={{ root: classes.text }}>
						Không tìm thấy dữ liệu
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(NonProduct);
